import {
  isHumanGateEnabled,
  isHumanReady,
} from '../../human-gate/index.js';
import { reportWidgetEvent } from '../../analytics/report-widget-event.js';
import type { CartSnapshot } from '@teo/widget-shared';

export type CartUpdatedReason = 'change' | 'refresh' | 'pagehide';

export function mapCartUpdatedPayload(
  snapshot: CartSnapshot,
  reason: CartUpdatedReason,
): {
  items_count?: number;
  cart_value?: number;
  currency?: string;
  confidence: CartSnapshot['confidence'];
  source: string;
  reason: CartUpdatedReason;
} {
  return {
    ...(snapshot.itemsCount != null ? { items_count: snapshot.itemsCount } : {}),
    ...(snapshot.cartValue != null ? { cart_value: snapshot.cartValue } : {}),
    ...(snapshot.currency ? { currency: snapshot.currency } : {}),
    confidence: snapshot.confidence,
    source: snapshot.sources[0] ?? 'unknown',
    reason,
  };
}

/**
 * Emit `cart_updated` after human-gate (when enabled). Returns false if gated.
 */
export function reportCartUpdated(
  snapshot: CartSnapshot,
  reason: CartUpdatedReason,
): boolean {
  if (isHumanGateEnabled() && !isHumanReady()) return false;
  reportWidgetEvent('cart_updated', mapCartUpdatedPayload(snapshot, reason));
  return true;
}
